import {apiSlice} from './apiSlice';
import {RateClass} from '../../types/optionTypes';

const bookCarModelName = 'App\\Models\\Bookables\\BookCar';

export const optionInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCarRateClasses: builder.query<RateClass[], void>({
            query: () => {
                const model = encodeURIComponent(bookCarModelName);
                return `/options/model?model=${model}&option=rate_class`;
            },
        })
    })
});

export const optionEndpoints = optionInjectedEndpoints.endpoints;
export const {
    useGetCarRateClassesQuery
} = optionInjectedEndpoints;
